module.exports = __webpack_public_path__ + "img/cp4-5.7d4312ff.jpg";